export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00548.50ce9073.png";